// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Nrkv","bigColWidth":"Table_bigColWidth__1Phqs","biggerColWidth":"Table_biggerColWidth__3rkXg","row":"Table_row__BBOpb","col":"Table_col__ZWd5n"};